<script>
  import {Line, mixins} from 'vue-chartjs'

  export default {
    extends: Line,
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    data () {
      let that = this

      return {
        options: {
          layout: {
            padding: {
              top: 20
            }
          },
          elements: {
            point: {
              radius: 0
            }
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: true
              },
              ticks: {
                autoSkipPadding: 50,
                maxRotation: 0
              }
            }],
            yAxes: [{
              display: true,
              gridLines: {
                display: true
              }
            }]
          },
          tooltips: {
            backgroundColor: 'rgba(220, 220, 220, 0.8)',
            bodyFontColor: '#2c2c2c',
            bodySpacing: 5,
            callbacks: {
              title: function (tooltipItem, data) {
                return null
              },
              label: function (tooltipItem, data) {
                return `${that.$currency}${tooltipItem.yLabel}`
              }
            },
            cornerRadius: 0,
            intersect: false,
            mode: 'label',
            xPadding: 10,
            yPadding: 10
          }
        }
      }
    },
    mounted () {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>


// WEBPACK FOOTER //
// src/js/components/charts/ForecastLineChart.vue